module.exports = __webpack_public_path__ + "img/ic-pickup.b16a421b.svg";